.root {
  width: 80%;
  margin: 0 auto;
}

.img {
  margin-bottom: 8px;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
}
